// import node module libraries
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Form, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import custom components
import { FormSelect } from 'components/elements/form-select/FormSelect';

// import axios
import axios from 'axios';

// Import authentication components
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

const SupportForm = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	const [isLoading, setIsLoading] = useState(false); // State for loading spinner
	const authHeader = useAuthHeader();
	const auth = useAuthUser();
	const isAuthenticated = useIsAuthenticated()

	const categoryOptions = [
		{ value: "Allgemein", label: 'Allgemein' },
		{ value: "Abrechnung", label: 'Abrechnung' },
		{ value: "Authentifizierung", label: 'Authentifizierung' },
		{ value: "Flow", label: 'Flow' },
		{ value: "Plan upgrade/downgrade", label: 'Plan upgrade/downgrade' }
	];

	const handleSubmitTicket = async (e) => {
		e.preventDefault();
		setIsButtonDisabled(true);
		setIsLoading(true); // Set loading to true

		// API-Call Options
		const options = {
			params: {
			},
			headers: {
				Authorization: authHeader,
				Accept: 'application/json'
			}
		};
		const data = {
			email_template_id: "da00256c-e302-11ef-8d7a-0242ac120009", // admin_new_service_ticket
			message: {
				from: "haeppy.app <noreply@haeppy.app>",
				to: "hello@haeppy-shopping.com",
				variables: {
					firstname: e.target.firstname.value,
					lastname: e.target.lastname.value,
					username: e.target.username.value,
					tenantId: e.target.tenantId.value,
					category: e.target.category.value,
					requestId: "SR-" + Math.floor(Math.random() * 1000000),
					request: e.target.request.value
				}
			}
		};

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.post(`${baseURL}/email/send-email`, data, options)
			.then(response => {
				setIsButtonDisabled(false);
				setIsLoading(false); // Stop loading
				
			})
			.catch((error) => {
				setIsButtonDisabled(false);
				setIsLoading(false); // Stop loading
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Deine Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut oder kontaktiere den Support über hello@haeppy-shopping.com.');
			})

		const datacc = {
			email_template_id: "959e110b-e309-11ef-8d7a-0242ac120009", // new_service_ticket_confirm
			message: {
				from: "haeppy.app <noreply@haeppy.app>",
				to: e.target.username.value,
				variables: {
					firstname: e.target.firstname.value,
					requestId: data.message.variables.requestId,
				}
			}
		};

		await axios.post(`${baseURL}/email/send-email`, datacc, options)
			.then(response => {
				handleShowNotification(setNotification, 'info', 'Erfolgreich', 'Dein Service Ticket mit der ID ' + data.message.variables.requestId + ' wurde erfolgreich erstellt. Wir werden uns schnellstmöglich bei dir melden.');
				setIsButtonDisabled(false);
				setIsLoading(false); // Stop loading
				e.target.reset();
				
			})
			.catch((error) => {
				setIsButtonDisabled(false);
				setIsLoading(false); // Stop loading
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Dein Service Ticket konnte nicht gesendet werden. Bitte versuche es später erneut oder kontaktiere den Support über hello@haeppy-shopping.com.');
			})
	};

	return (
		<section className="py-10">
			<Container>
				{notification.show && (
					<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
				)}
				<Row>
					<Col md={{ offset: 2, span: 8 }} xs={12}>
						<div className="mb-3">
							{/* lead  */}
							<p className="lead mb-8">
								{t("Can't find an answer to your question or problem? Don't worry and contact the Help Desk team.")}
							</p>
							<div className="d-flex justify-content-between">
								<span>{t('Contact Information')}</span>
								<div className="text-end">
									<Link to="mailto://hello@haeppy-shopping.com">hello@haeppy-shopping.com</Link>
								</div>
							</div>
						</div>
						<div>
							{/* form - submit a request */}
							<Card className="border">
								<Card.Body className="p-5">
									<h2 className="mb-4 fw-semi-bold">{t('Create Service Ticket')}</h2>
									{/* form  */}
									<Form onSubmit={handleSubmitTicket}>
										{/* First Name  */}
										<Form.Group className="mb-3" controlId="firstname">
											<Form.Label>
												{t('First Name')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												type="text"
												placeholder={t('Enter First Name')}
												autoComplete="given-name"
												defaultValue={auth.first_name}
												required
											/>
										</Form.Group>

										{/* Last Name  */}
										<Form.Group className="mb-3" controlId="lastname">
											<Form.Label>
												{t('Last Name')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												type="text"
												placeholder={t('Enter Last Name')}
												autoComplete="last-name"
												defaultValue={auth.last_name}
												required
											/>
										</Form.Group>

										{/* Username  */}
										<Form.Group className="mb-3" controlId="username">
											<Form.Label>
												{t('Username')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												type="text"
												placeholder={t('Enter Username')}
												autoComplete="username"
												defaultValue={auth.username}
												required
											/>
										</Form.Group>

										{/* Tenant  */}
										<Form.Group className="mb-3" controlId="tenantId">
											<Form.Label>
												{t('Tenant ID')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												type="text"
												placeholder={t('Enter Tenant ID')}
												defaultValue={auth.tenant_id}
												required
											/>
										</Form.Group>

										{/* Select Category  */}
										<Form.Group className="mb-3" controlId="category">
											<Form.Label>
												{t('Category')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												as={FormSelect}
												placeholder={t('Choose Category')}
												options={categoryOptions}
												required
											/>
										</Form.Group>

										{/* Description  */}
										<Form.Group className="mb-3" controlId="request">
											<Form.Label>
												{t('Request')} <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												as="textarea"
												rows={3}
												placeholder={t('Please describe your request in detail')}
												required
											/>
										</Form.Group>

										{/* Button */}
										<Button variant="primary" type="submit" disabled={isButtonDisabled}>
											{isLoading ? (
												<>
													<Spinner animation="border" size="sm" className="me-2" />
													{t('Create Service Ticket')}
												</>
											) : (
												t('Create Service Ticket')
											)}
										</Button>
									</Form>
								</Card.Body>
							</Card>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default SupportForm;
